import React, { FunctionComponent } from 'react'

import { GlobalStyle, theme, ThemeContext } from '../../style'
import { Footer } from '../Footer'
import { Inner } from './style'
import { Props } from './type'

export const Layout: FunctionComponent<Props> = ({ children }) => (
  <ThemeContext.Provider value={theme}>
    <GlobalStyle />
    <Inner>{children}</Inner>
    <Footer />
  </ThemeContext.Provider>
)
